import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Col, Row, Breadcrumb, Card } from 'react-bootstrap';
import { useAuth } from "../../context/AuthContext";
import config from "../../config";
import { useNavigate } from 'react-router-dom';
import nouserImg from '../../assets/images/no_user.png';
import { InputNumber } from 'primereact/inputnumber';
import CustomToast from '../../components/CustomToast';

const TaskLimitPage = () => {
    const { accessToken } = useAuth();
    const [taskLimits, setTaskLimits] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [maxTasks, setMaxTasks] = useState(0);
    const navigate = useNavigate();
  const toastRef = useRef(null);
    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
      };


    // Fetch Task Limits
    const fetchTaskLimits = async (query = '') => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/projectRoutes/fetch-all-task-limits`, {
                params: { searchQuery: query },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setTaskLimits(response.data.data);
        } catch (error) {
            console.error('Error fetching task limits:', error);
        }
    };

    useEffect(() => {
        fetchTaskLimits();
    }, []);

    // Handle Search
    const handleSearch = () => {
        fetchTaskLimits(searchQuery);
    };

    // Open Edit Dialog
    const openEditDialog = (user) => {
        setSelectedUser(user);
        setMaxTasks(user.max_tasks_per_day);
        setEditDialogVisible(true);
    };

    // Save Edited Task Limit
    const saveTaskLimit = async () => {
        if (maxTasks <= 0) {
            showMessage("error", 'Max tasks per day must be greater than 0.');  
            return;
        }

        try {
            await axios.post(
                `${config.apiBASEURL}/projectRoutes/post-task-limits`,
                {
                    user_id: selectedUser.user.user_id,
                    max_tasks_per_day: maxTasks,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            fetchTaskLimits(searchQuery);
            setEditDialogVisible(false);
        } catch (error) {
            console.error('Error saving task limit:', error);
        }
    };

    return (
        <Row className="body_content">
            <Row className="mx-0">
                <Col md={6} lg={6} className="mb-4">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                            <i className="pi pi-angle-left"></i> Back
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Task Limit</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
                <Col md={6} lg={6} className="d-flex justify-content-end mb-4">
                    <InputText
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search by name"
                        className="me-2"
                        style={{ width: '200px' }}
                    />
                    <Button
                        title="Search"
                        icon="pi pi-search"
                        onClick={handleSearch}
                        style={{ height: '46px' }}
                        severity='secondary'
                        className='px-4'
                    />
                </Col>
                <Col className="mx-0">
                    <ul className='tasklimit_List'>
                        {taskLimits.map((taskLimit) => (
                            <li key={taskLimit.usertasklimit_id} >
                                <Card>
                                    <Card.Body>
                                        <div className="d-flex justify-content-start">
                                            <img
                                                src={taskLimit.user.profileImage?.image_url || nouserImg}
                                                alt="Profile"
                                                className='me-3'
                                                style={{ height: '80px', width: '80px', objectFit: 'cover', borderRadius: '50%' }}
                                            />
                                            <div>
                                                <h6 className="font-bold mb-0">{taskLimit.user.first_name} {taskLimit.user.last_name}</h6>
                                                <p className="text-muted mb-0"><small>{taskLimit.user.user_type}</small></p>
                                                <p>
                                                    <small className="text-muted">Max Tasks per Day :</small>
                                                    <b className='text-danger ps-1'>{taskLimit.max_tasks_per_day}</b>
                                                    <Button
                                                        title="Edit"
                                                        icon="pi pi-pencil"
                                                        onClick={() => openEditDialog(taskLimit)}
                                                        className="ms-2 border-0 p-0"
                                                        outlined
                                                        severity='help'
                                                        style={{ position: 'absolute', top: '15px', right: '15px' }}

                                                    />
                                                </p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </li>
                        ))}
                    </ul>

                </Col>

                <Dialog
                    header="Edit Task Limit"
                    style={{ width: '340px' }}
                    visible={editDialogVisible}
                    onHide={() => setEditDialogVisible(false)}
                    footer={
                        <div>
                            <Button
                                label="Cancel"
                                icon="pi pi-times"
                                onClick={() => setEditDialogVisible(false)}
                                className="me-2 py-2"
                                severity='secondary'
                            />
                            <Button
                                label="Save"
                                icon="pi pi-check"
                                onClick={saveTaskLimit}
                                className="py-2"
                                severity='success'
                            />
                        </div>
                    }
                >
                    <div>
                        <p>
                            Editing Task Limit for{' '}
                            <strong>
                                {selectedUser?.user.first_name} {selectedUser?.user.last_name}
                            </strong>
                        </p>
                        <InputNumber
                            value={maxTasks}
                            onValueChange={(e) => setMaxTasks(e.value || 0)} // Ensures a valid whole number
                            placeholder="Max Tasks per Day"
                            className="w-100 mt-2"
                            min={1} // Prevents values below 1
                            step={1} // Ensures only whole numbers can be entered
                            useGrouping={false} // Optional: Removes grouping (e.g., thousand separators)
                        />
                    </div>
                </Dialog>
                <CustomToast ref={toastRef} />
            </Row>
        </Row>
    );
};

export default TaskLimitPage;
